import { isBrowser } from '@/constants/index';
import { IEditRequest } from 'interfaces/ApiType/apiType';

import { baseAPI as api } from './index';

const editFile = async ({
  files,
  recaptchaToken,
  fileId,
  config,
}: IEditRequest) => {
  const url = `/file/${fileId}/edit`;
  const body = new FormData();
  body.append('file', files);
  const response = await api.post(
    url,
    body,
    isBrowser && localStorage.getItem('token')
      ? {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            RecaptchaToken: recaptchaToken,
          },
          ...config,
        }
      : {
          headers: {
            RecaptchaToken: recaptchaToken,
          },
          ...config,
        }
  );
  return response;
};

export default editFile;
